import { DataHeader, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommGroupFilter extends Layout {
    dataheaderMobileCommUnit: DataHeader;
    sourceMCFilterJunctionDriver: DataSource;
    sourceMCFilterJunctionUnit: DataSource;
    sourceMCGroup: DataSource;
    tableMCFilterJunctionUser: Table;
    tableMCFilterJunctionDriver: Table;
    tableMCFilterJunctionUnit: Table;
}
